import {DataObjectId} from './data-object'
import {JSONLikeValue} from './diff'
import {Hub, HubJSON, isTaskWithoutPermissions} from './hubs'

export interface Subtask {
  id: DataObjectId
  title: string
  location: DataObjectId
  isArchived: number | undefined
  isCompleted: boolean
  isDeleted?: boolean
  stickers: {[id: string]: JSONLikeValue}
}

export interface SubtaskList {
  subtasks: {[id: string]: Subtask}
  order: DataObjectId[]
}

export const createSubtaskFromTask = (
  task: Hub | HubJSON
): Subtask | undefined => {
  if (!task || isTaskWithoutPermissions(task)) {
    return undefined
  }
  return {
    id: task.id,
    title: task.title,
    isCompleted: task.data?.gtd?.state?.stage === 'done',
    isArchived: task.complete,
    location: task.location,
    stickers: task.stickers ?? {},
    ...(task.deleted ? {isDeleted: true} : {})
  }
}
